import { Checkbox, Text } from "@marekl/adminer/components";
import type { TeamSeasonDocument } from "../../lib/queries/seasonDocuments";
import { allTicked, documentHref } from "../../lib/documentConsent";
import type { ID } from "../../lib/id";
import styles from "./DocumentConsentList.module.css";

export interface DocumentConsentListProps {
  /** The pending documents, one checkbox each. */
  documents: TeamSeasonDocument[];
  ticked: ReadonlySet<ID>;
  onToggle: (versionId: ID, checked: boolean) => void;
  /** Said in red while a box is unticked: why the confirm is off. */
  missingMessage: string;
  disabled?: boolean;
}

/**
 * One required checkbox per pending season document, the document's name a
 * link into a new tab. The body of the „Registrovat tým do sezóny"
 * confirmation and of the „Souhlas s dokumenty" box on the team page. The
 * server asks every pending one (seasondoc.CheckTx), so the caller keeps its
 * confirm off until `allTicked` and this says why beneath the boxes.
 *
 * The link sits inside the label on purpose: a click on interactive
 * content does not activate a label, so opening the document never ticks
 * the box.
 */
export function DocumentConsentList({
  documents,
  ticked,
  onToggle,
  missingMessage,
  disabled,
}: DocumentConsentListProps) {
  return (
    <div className={styles.wrap}>
      <ul className={styles.list}>
        {documents.map((d) => (
          <li key={d.document_id}>
            <Checkbox
              required
              label={
                <>
                  Seznámil(a) jsem se s dokumentem{" "}
                  <a href={documentHref(d)} target="_blank" rel="noopener noreferrer">
                    {d.name}
                  </a>{" "}
                  a souhlasím s ním
                  {d.consent && <Text variant="muted"> (nová verze)</Text>}
                </>
              }
              checked={ticked.has(d.version_id)}
              disabled={disabled}
              onChange={(e) => onToggle(d.version_id, e.target.checked)}
            />
          </li>
        ))}
      </ul>
      {!allTicked(documents, ticked) && <p className={styles.missing}>{missingMessage}</p>}
    </div>
  );
}
